(function () {
  if (window.__ccCartUiLoaded) return;
  window.__ccCartUiLoaded = true;

  function rootUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '/') + path.replace(/^\//, '');
  }

  function refreshCartUi() {
    document.dispatchEvent(new CustomEvent('cart:build'));
  }

  function reopenCoupon(code, text) {
    window.setTimeout(function () {
      document.querySelectorAll('[data-cc-cart-coupon]').forEach(function (details) {
        details.open = true;
        var liveMessage = details.querySelector('[data-cc-coupon-message]');
        var liveInput = details.querySelector('input[name="discount"]');
        if (liveInput && code) liveInput.value = code;
        if (liveMessage && text) liveMessage.textContent = text;
      });
    }, 450);
  }

  document.addEventListener('click', async function (event) {
    var button = event.target.closest('[data-cc-cart-add]');
    if (!button) return;

    event.preventDefault();
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      var response = await fetch(rootUrl('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      if (!response.ok) throw new Error('Unable to add product');
      await response.json();
      button.textContent = 'Added';
      refreshCartUi();
      document.dispatchEvent(new CustomEvent('cart:open'));
      setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;
      }, 1200);
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Try again';
      console.error('Cotton Culture cart recommendation add:', error);
      setTimeout(function () { button.textContent = originalText; }, 1600);
    }
  });

  document.addEventListener('change', async function (event) {
    var select = event.target.closest('.cart-variant-select');
    if (!select) return;

    var newVariantId = select.value;
    var lineKey = select.getAttribute('data-line-key');
    var oldVariantId = select.getAttribute('data-current-variant');
    var quantity = parseInt(select.getAttribute('data-quantity'), 10) || 1;
    if (!newVariantId || (!lineKey && !oldVariantId) || newVariantId === oldVariantId) return;

    select.disabled = true;
    try {
      var removeResponse = await fetch(rootUrl('cart/change.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey || oldVariantId, quantity: 0 })
      });
      if (!removeResponse.ok) throw new Error('Unable to update size');

      var addResponse = await fetch(rootUrl('cart/add.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(newVariantId), quantity: quantity }] })
      });
      if (!addResponse.ok) throw new Error('Unable to update size');
      await addResponse.json();
      refreshCartUi();
    } catch (error) {
      select.disabled = false;
      console.error('Cotton Culture cart variant switch:', error);
    }
  });

  async function applyCartCoupon(form) {
    if (!form || form.dataset.ccBusy === 'true') return;
    var input = form.querySelector('input[name="discount"]');
    var submit = form.querySelector('.cc-cart-coupon__apply');
    var message = form.querySelector('[data-cc-coupon-message]');
    var code = input ? input.value.trim() : '';

    if (!code) {
      if (message) message.textContent = 'Please enter a coupon code.';
      if (input) input.focus();
      return;
    }

    var oldLabel = submit ? submit.textContent : '';
    form.dataset.ccBusy = 'true';
    if (submit) { submit.disabled = true; submit.textContent = 'Applying…'; }
    if (message) message.textContent = '';

    try {
      var response = await fetch(rootUrl('cart/update.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: code })
      });
      if (!response.ok) throw new Error('Coupon could not be applied');
      await response.json();
      refreshCartUi();
      reopenCoupon(code, 'Coupon submitted. Any eligible savings appear in your cart or at checkout.');
    } catch (error) {
      if (message) message.textContent = 'We could not apply this coupon. Please check the code and try again.';
      console.error('Cotton Culture coupon:', error);
    } finally {
      delete form.dataset.ccBusy;
      if (submit) { submit.disabled = false; submit.textContent = oldLabel || 'Apply'; }
    }
  }

  // Nested forms are invalid HTML: the coupon uses a button and delegated
  // click/Enter handlers, preserving CartDrawerForm for checkout.
  document.addEventListener('click', function (event) {
    var applyButton = event.target.closest('[data-cc-cart-coupon] .cc-cart-coupon__apply');
    if (applyButton) {
      event.preventDefault();
      applyCartCoupon(applyButton.closest('[data-cc-coupon-form]'));
      return;
    }

    var removeButton = event.target.closest('#CartDrawer .cc-cart-item__remove a');
    if (!removeButton) return;
    event.preventDefault();
    if (removeButton.dataset.ccBusy === 'true') return;
    var line = removeButton.closest('[data-key]');
    var key = line && line.getAttribute('data-key');
    if (!key) { window.location.assign(removeButton.href); return; }

    removeButton.dataset.ccBusy = 'true';
    removeButton.setAttribute('aria-disabled', 'true');
    fetch(rootUrl('cart/change.js'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to remove cart item');
      return response.json();
    }).then(function (cart) {
      refreshCartUi();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }).catch(function (error) {
      console.error('Cotton Culture cart remove:', error);
      removeButton.removeAttribute('aria-disabled');
      delete removeButton.dataset.ccBusy;
      window.location.assign(removeButton.href);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var field = event.target.closest('[data-cc-coupon-form] input[name="discount"]');
    if (!field) return;
    event.preventDefault();
    applyCartCoupon(field.closest('[data-cc-coupon-form]'));
  });

})();
